import {ActionTypes} from "./types";
import axios from "axios";
import {getAccessToken} from "../../auth/auth";

const host = process.env.REACT_APP_HOST

export const search = (queryParams) => {

  const config = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json'
    },
    params: queryParams ? queryParams : {
      page: 0,
      size: 1000
    }
  }

  return async dispatch => {
    return axios.get(`${host}/country`, config)
      .then(
        response => dispatch(setCountries(response.data)),
        err => console.log(err)
      );
  }
}

export const getAllCountries = () => {

  const config = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json'
    }
  }

  return async dispatch => {
    return axios.get(`${host}/country/iso`, config)
      .then(
        response => dispatch(setAllCountries(response.data)),
        err => console.log(err)
      );
  }
}

export const setCountries = (payload) => ({
  type: ActionTypes.SET_COUNTRIES,
  payload: payload,
});

export const setAllCountries = (payload) => ({
  type: ActionTypes.SET_ALL_COUNTRIES,
  payload: payload,
});